export default __webpack_public_path__ + "static/media/1985.b7287f60.png";